module.exports = __webpack_public_path__ + "static/_ontarioTechLogo-db8e6e9e145777fe6d056f6092cc447e.png";